import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { Facet } from 'src/redux/productsQuery/types/Facet';

export const selectFacetByKey = (state: ReduxApplicationState, uid: string): Facet | null => {
  return state.productsQuery.facets.find((facet) => facet.key === uid) || null;
};

export const selectTotalActiveOptions = (state: ReduxApplicationState) => {
  return state.productsQuery.facets.reduce((total, facet) => {
    const activeOptionsCount = facet.options.filter((option) => option.active).length;

    total = total + activeOptionsCount;

    return total;
  }, 0);
};

export const selectActiveFacets = (state: ReduxApplicationState) => {
  return state.productsQuery.facets.filter((facet) =>
    facet.options.some((option) => option.active),
  );
};

export const selectActiveSortOption = (state: ReduxApplicationState) => {
  return state.productsQuery.sortOptions.find((option) => option.active) || null;
};
